import { MapPaneProps } from "../types/map";

// Pixel correction for map tiles
export const PX_CORRECTION: number = 2;
export const MAP_ZOOM_DELTA: number = 0.25; // Zoom out a bit after fitting to bbox
export const MAP_ZOOM_SNAP: number = 0.25 ; // Snap zoom levels to this
// Find my position marker id
export const FIND_MY_POS_MARKER_ID = "myPosition";
// GPS location marker id
export const GPS_POSITION_MARKER_ID = "gps-position";
export const GPS_COORDINATE_MARKER_ID = "gps-coordinate";
export const MIN_DISTANCE_BETWEEN_GPS_POINTS = 4;
// Google Place location marker id
export const PLACE_LOCATION_MARKER_ID = "place-location";

// --- Map panes and order --- //
// General leaflet pane offset
export const PANE_ZINDEX_OFFSET = 300;
export const PANE_LIST: MapPaneProps[] = [
   // { label: "drawVertexPane", zIndex: PANE_ZINDEX_OFFSET + 63},
   // { label: "drawLayerPane", zIndex:  PANE_ZINDEX_OFFSET + 64},
   // { label: "drawMarkerPane", zIndex:  PANE_ZINDEX_OFFSET + 65},
   // Match Leaflet's tooltip pane: above drawing paths (400) and handles (600), below popups (700).
   { label: "measurementTooltipPane", zIndex: 650 },
   { label: "measurementFakeMarkerPane", zIndex: -100 },
   { label: "linesBuffersPane", zIndex: PANE_ZINDEX_OFFSET },
   { label: "linesAreaBearingPane", zIndex: PANE_ZINDEX_OFFSET + 1 },
   { label: "polygonsBackgroundPane", zIndex: PANE_ZINDEX_OFFSET - 1 },
   { label: "polygonsAreaBearingPane", zIndex: PANE_ZINDEX_OFFSET + 2 },
   { label: "polygonsPane", zIndex: PANE_ZINDEX_OFFSET + 3 },
   { label: "linesPane", zIndex: PANE_ZINDEX_OFFSET + 4 },
   { label: "mapFeaturePane", zIndex: PANE_ZINDEX_OFFSET + 5 },
   { label: "pointsCirclePane", zIndex: PANE_ZINDEX_OFFSET + 6 },
   { label: "pointsPane", zIndex: PANE_ZINDEX_OFFSET + 6 },
   { label: "labelsPane", zIndex: PANE_ZINDEX_OFFSET + 6 },
   { label: "projectOriginsPolygonsPane", zIndex: PANE_ZINDEX_OFFSET + 7 },
   { label: "projectOriginsLinesPane", zIndex: PANE_ZINDEX_OFFSET + 8 },
   { label: "projectEditablePolygonsPane", zIndex: PANE_ZINDEX_OFFSET + 9 },
   { label: "projectEditableLinesPane", zIndex: PANE_ZINDEX_OFFSET + 10 },
   { label: "projectOriginsPointsPane", zIndex: PANE_ZINDEX_OFFSET + 11 },
   { label: "projectEditablePointsPane", zIndex: PANE_ZINDEX_OFFSET + 12 },
   { label: "projectOriginsLabelsPane", zIndex: PANE_ZINDEX_OFFSET + 13 },
   { label: "projectEditableLabelsPane", zIndex: PANE_ZINDEX_OFFSET + 14 },
   { label: "projectMarkersPane", zIndex: PANE_ZINDEX_OFFSET + 15 },
   { label: "mapMarkersPane", zIndex: PANE_ZINDEX_OFFSET + 16 },
   { label: "activityMarkersPane", zIndex: PANE_ZINDEX_OFFSET + 17 },
   { label: "estateMarkersPane", zIndex: PANE_ZINDEX_OFFSET + 18 },
   { label: "toolTipPane", zIndex: PANE_ZINDEX_OFFSET + 61 },
];

// --- Style options --- // 
// Measurement and draw
export const measureLinePathOptions = {
   color: '#D8E9A8',
   fillColor: '#D8E9A8',
   weight: 1.5,
   measure: true,
}

export const measureLineTemplineStyle = {
   color: '#D8E9A8',
   weight: 1.5,
   measure: true,
}

export const measureLineHintlineStyle = {
   color: '#D8E9A8',
   dashArray: '10',
   weight: 1.5,
   measure: true,
}

export const measurePolygonPathOptions = {
   color: '#D8E9A8',
   fillColor: '#D8E9A8',
   weight: 1.5,
   measure: true,
}

export const measurePolygonTemplineStyle = {
   color: '#D8E9A8',
   weight: 1.5,
   measure: true,
}

export const measurePolygonHintlineStyle = {
   color: '#D8E9A8',
   dashArray: [5, 5],
   measure: true,
}

export const drawLinePathOptions = {
   color: '#D8E9A8',
   fillColor: '#D8E9A8',
   weight: 1.5,
   type: 'line',
}

export const drawLineTemplineStyle = {
   color: '#D8E9A8',
   weight: 1.5,
   type: 'line',
}

export const drawLineHintlineStyle = {
   color: '#D8E9A8',
   dashArray: [5, 5],
   weight: 1.5,
   type: 'line',
}

export const drawPolygonPathOptions = {
   color: '#D8E9A8',
   fillColor: '#D8E9A8',
   weight: 1.5,
   type: 'poly',
}

export const drawPolygonTemplineStyle = {
   color: '#D8E9A8',
   weight: 1.5,
   type: 'poly',
}

export const drawPolygonHintlineStyle = {
   color: '#D8E9A8',
   dashArray: [5, 5],
   //weight: [1, 1],
   type: 'poly',
}

export const measureLineOptions = {
   pathOptions: drawLinePathOptions,
   templineStyle: drawLineTemplineStyle,
   hintlineStyle: drawLineHintlineStyle,
   tooltips: false,
   snapDistance: 5,
}

export const measurePolygonOptions = {
   pathOptions: drawPolygonPathOptions,
   templineStyle: drawPolygonTemplineStyle,
   hintlineStyle: drawPolygonHintlineStyle,
   tooltips: false,
   snapDistance: 5,
}

export const drawLineOptions = {
   pathOptions: drawLinePathOptions,
   templineStyle: drawLineTemplineStyle,
   hintlineStyle: drawLineHintlineStyle,
   tooltips: true,
   snapIgnore: true,
   finishOn: "dblclick" as "dblclick",
   allowSelfIntersection: true,
}

export const drawPolygonOptions = {
   pathOptions: drawPolygonPathOptions,
   templineStyle: drawPolygonTemplineStyle,
   hintlineStyle: drawPolygonHintlineStyle,
   tooltips: true,
   snappable: true,
   snapDistance: 15,
   allowSelfIntersection: false,
}

export const drawHelpCircleOptions = {
   // Helpers must not become cut targets, snapping targets or intercept clicks.
   pmIgnore: true,
   snapIgnore: true,
   interactive: false,
   color: 'black',
   fillColor: '#D8E9A8',
   fillOpacity: 0.3,
   weight: 0.5,
}
export const measureCircleOptions = {
   ...measurePolygonOptions,
   continueDrawing: false,
};
